import { render } from "./CorrectionReportsTable.vue?vue&type=template&id=113ad2d3"
import script from "./CorrectionReportsTable.vue?vue&type=script&lang=js"
export * from "./CorrectionReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__